import React, { useState } from 'react';
import { Arrows, Arrow, AttachedButton } from './style';
import { Row, Title, Input } from '../../style';

import arrowTop from '../../assets/arrow_top.svg';
import arrowBottom from '../../assets/arrow_bot.svg';

const getValueInfo = (value, type) => {
    switch (type) {
        case 'number':
            return value;
        case 'percent':
            return `${value}%`;
        case 'dollar':
            return `$${value}`;
        default:
            return value;
    }
};

const reg = /^\d+$/;

const DescriptionValue = ({ text, value, isActive, changeIndex, condition, changeValue, min, max, step, type }) => {
    const [focus, setFocus] = useState(false);
    const showValue = focus ? value : getValueInfo(value, type);

    return (
        <Row margin='4px 0'>
            <Title>
                {text}
            </Title>
            <AttachedButton>
                <Input
                    onFocus={() => {
                        setFocus(true);
                        changeIndex(condition);
                    }}
                    onBlur={() => {
                        setFocus(false);
                        if (value === '') {
                            changeValue(0);
                        }
                    }}
                    caretColor={type === 'decimal' ? 'transparent' : null}
                    isActive={isActive}
                    value={showValue}
                    onChange={(event) => {
                        if (type === 'decimal') {
                            return null;
                        }
                        const _value = event.target.value;
                        const number = _value;

                        if (_value === '') {
                            changeValue(_value);
                            return null;
                        }
                        if (!reg.test(_value)) {
                            return null;
                        }
                        if (number > max || number < min) {
                            return null;
                        }

                        changeValue(+_value);
                    }}
                />
                {
                    isActive ? (
                        <Arrows>
                            <Arrow
                                src={arrowTop}
                                alt=''
                                onClick={() => {
                                    const result = value + step;
                                    if (result > max) {
                                        return null;
                                    }
                                    changeValue(result);
                                }}/>
                            <Arrow
                                src={arrowBottom}
                                alt=''
                                onClick={() => {
                                    const result = value - step;
                                    if (result < min) {
                                        return null;
                                    }
                                    changeValue(result);
                                }}/>
                        </Arrows>
                    ) : null
                }
            </AttachedButton>
        </Row>
    );
};

export default DescriptionValue;
